import type { Context } from 'react';
import { createContext } from 'react';
import { useI18nWrapperViewModel } from '../../hooks/useI18nWrapperViewModel';

export interface I18nWrapperContextInterface {
  useI18nWrapperViewModel: typeof useI18nWrapperViewModel;
}

export const I18nWrapperContext: Context<I18nWrapperContextInterface> =
  createContext<I18nWrapperContextInterface>({
    useI18nWrapperViewModel,
  });
